import { render } from "./pmMonitor.vue?vue&type=template&id=ff0558e0&scoped=true"
import script from "./pmMonitor.vue?vue&type=script&lang=js"
export * from "./pmMonitor.vue?vue&type=script&lang=js"

import "./pmMonitor.vue?vue&type=style&index=0&id=ff0558e0&scoped=true&lang=scss"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff0558e0"]])

export default __exports__